<div *ngIf="label() || infoIconSrc()" class="xp-field__label-row">
	<span class="xp-field__label">{{ label() }}</span>
	<img *ngIf="infoIconSrc()"
	     class="xp-field__info-icon"
	     [src]="infoIconSrc()"
	     [matTooltip]="infoTooltip()"
	     alt="" />
</div>
<ng-content></ng-content>
<div *ngIf="showError()" class="xp-field__error">{{ errorText() }}</div>
